import { toast } from 'react-toastify';
import { authAxiosInstance } from '../../utils/axiosConfig';
import { showError } from '../../utils/Utils';

export const createMillDispatch = async (data) => {
    try {
        const createResp = await authAxiosInstance.post('/millDispatch', data);
        return createResp;
    } catch (error) {
        console.log(error);
        toast.error('failed to create mill dispatch');
    }
};

export const deleteMillDispatch = async (id) => {
    try {
        const deleteResp = await authAxiosInstance.delete(
            `/millDispatch/${id}`
        );
        return deleteResp;
    } catch (error) {
        console.log(error);
        showError(error);
    }
};
